import assign from "lodash/fp/assign";
import apis from "../../core/apis.js";

class UserResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  search(query = "", params) {
    return this.$resource(apis.user + "autocomplete/").get(
      assign(params, { query })
    );
  }

  get(id) {
    return this.$resource(apis.user + id).get();
  }

  getAll(params) {
    return this.$resource(apis.user).get(params);
  }

  find(q) {
    return this.$resource(apis.user + "find").get({ q });
  }

  update(id, item) {
    return this.$resource(apis.user + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }

  post(item) {
    return this.$resource(apis.user).save(item);
  }

  notes(query) {
    return this.$resource(apis.notes).get(query);
  }

  addNote(id, item) {
    return this.$resource(apis.user + id + "/add_note/").save(item);
  }

  charge(id, item) {
    return this.$resource(apis.user + id + "/charge/").save(item);
  }

  setCorporate(id, item) {
    return this.$resource(apis.user + id + "/update_corporate").save(item);
  }

  setCorpRole(id, item) {
    return this.$resource(apis.user + id + "/update_corporate_role").save(item);
  }

  updateCity(id, item) {
    return this.$resource(apis.user + id + "/update_city").save(item);
  }
  transactions(params) {
    return this.$resource(apis.transactions).get(params);
  }

  updateNote(id, noteId, item) {
    return this.$resource(apis.user + id + "/note/" + noteId, null, {
      update: { method: "PATCH" },
    }).update(item);
  }

  updateAction(id, name, item) {
    return this.$resource(apis.user + id + `/${name}`).save(item);
  }
  updateActionPutMethod(id, name, item) {
    return this.$resource(apis.user + id + `/${name}`, null, {
      update: { method: "PUT" },
    }).update(item);
  }
  verificationCode(params) {
    return this.$resource(apis.user + "verification_code").get(params);
  }

  resendVerification(item) {
    return this.$resource(apis.user + "generate_verification_code").save(item);
  }

  verificationEmail(params) {
    return this.$resource(apis.user + "verification_email").get(params);
  }

  resendVerificationEmail(item) {
    return this.$resource(apis.user + "generate_verification_email").save(item);
  }

  resetPassword(params) {
    return this.$resource(apis.user + "reset_password").save(params);
  }

  unblockPhone(params) {
    return this.$resource(apis.user + "unblock_phone").save(params);
  }
}

export default UserResource;



// WEBPACK FOOTER //
// ./src/resources/user/user.resource.js